import React from 'react';

const SplashScreen = () => {
  return (
    <div className="fixed inset-0 bg-white z-[9999] flex flex-col items-center justify-center">
      <div className="relative w-48 h-48 mb-6">
        <img
          src="/images/favico/agora.png"
          alt="Ágora"
          className="w-full h-full object-contain animate-pulse"
        />
        <div className="absolute inset-0 border-4 border-transparent border-t-[#4F46E5] rounded-full animate-spin"></div>
      </div>
      <h2 className="text-xl font-bold text-gray-800 tracking-widest animate-fade-in">
        ÁGORA
      </h2>
    </div>
  );
};

export default SplashScreen;